import { Checkbox } from '@klear/ui/components/checkbox'
import { Label } from '@klear/ui/components/label'
import { cn } from '@klear/ui/lib/utils'
import type { LucideIcon } from 'lucide-react'
import { useFormContext, Controller } from 'react-hook-form'
import get from 'lodash/get'

interface FormCheckboxProps {
  name: string
  label: string
  icon?: LucideIcon
  disabled?: boolean
  isEditing?: boolean
  className?: string
  onChange?: (checked: boolean) => void
}

export default function FormCheckbox({
  name,
  label,
  icon: Icon,
  disabled,
  isEditing = true,
  className,
  onChange: onChangeProp
}: FormCheckboxProps) {
  const {
    control,
    clearErrors,
    formState: { errors }
  } = useFormContext()

  const fieldError = get(errors, name)
  const errorMessage = get(fieldError, 'message')

  return (
    <div className={cn('space-y-2', className)}>
      <Label htmlFor={name} className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4" />}
        {label}
      </Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Checkbox
            id={name}
            checked={field.value}
            onCheckedChange={(checked) => {
              field.onChange(checked)
              clearErrors(name)
              onChangeProp?.(checked === true)
            }}
            disabled={disabled || !isEditing}
            className={fieldError ? 'border-destructive' : ''}
          />
        )}
      />
      {errorMessage && <p className="text-sm text-destructive">{errorMessage.toString()}</p>}
    </div>
  )
}
